import React from 'react'
import LoginPage from './LoginPage'

export * from './LoginPage'
export default React.memo(LoginPage)
